import TymberSite from "../models/tymberSite";

export default function makeSite(siteObject, settingsObject, groupSettings, themeObject) {
  return new TymberSite(siteObject, settingsObject, groupSettings, themeObject);
}
